<template>
  <div class="page1">
    <EForm :formColumns="formColumns" :rowSize="5" :optionsBtn="true" :actionBtn="false" :formData="searchForm"
      ref="form" @onSearch="onSearch" :searchFlag="true" :exportShow="false"></EForm>
    <ETable
      :tableTitle="tableTitle"
      :tableData="tableData"
      :needPagination="true"
      :count="count"
      @changePage="changePage"
      @changeSize="changeSize"
      :page="searchForm.current"
      :page_size="searchForm.size"
    >
      <el-table-column fixed="right" label="操作" width="300px">
        <template slot-scope="scope">
          <div>
            <el-dropdown v-if="scope.row.signFlowStatus==='2'" trigger="click" @command="handleCommand" style="margin-right:10px">
              <el-button type="primary" size="mini" @click="download(scope.row.flowId)">
                下载合同<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="file in files" :key="file.downloadUrl" :command="file.downloadUrl">{{ file.fileName }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button size="mini" v-if="scope.row.signFlowStatus==='1'" type="primary" @click="urge(scope.row.flowId)">
              催办
            </el-button>
            <el-button size="mini" v-if="scope.row.signFlowStatus==='1'" type="primary" @click="revoke(scope.row.flowId)">
              撤回
            </el-button>
          </div>
        </template>
      </el-table-column>
      <div slot="signFlowStatus" slot-scope="scope">
        {{ scope.data.signFlowStatus == '0' ? '草稿' : scope.data.signFlowStatus == '1' ? '签署中' : scope.data.signFlowStatus == 2 ? '完成' : scope.data.signFlowStatus == 3 ? '撤销' : scope.data.signFlowStatus == 5 ? '过期' : scope.data.signFlowStatus == 7 ? '拒签' : '-'}}
      </div>
    </ETable>
  </div>
</template>

<script>
  import ETable from '@/components/ETable';
  import Http from '@/service/http';
  import EDialog from '@/components/EDialog';
  import EButton from '@/components/EButton';
  import EForm from '@/components/EForm';
  import { identity_type, status } from '@/assets/js/config';
  import vxRule from '@/assets/js/formValidate';
  import { otherMixin } from '@/components/mixin';
  import {mapGetters} from 'vuex'
  export default {
    name: 'shopInfo',
    mixins: [otherMixin],
    data() {
      return {
        formColumns: [
        {
          title: '流程标题',
          type: 'text',
          property: 'signFlowTitle',
          placeHolder: '请输入',
          show: true,
        }],
        tableTitle: [
          {
            label: '流程标题',
            prop: 'signFlowTitle',
          },
          {
            label: '发起时间',
            prop: 'createTime',
          },
          {
            label: '流程状态',
            prop: 'signFlowStatus',
            type: 'slot'
          }
        ],
        tableData: [],
        searchForm: {
          contractNo: null,
          flowName: null,
          flowStatus: null,
          current: 1,
          size: 10,
        },
        count: null,
        exportData: {},
        files:[],
        showfiles: false
      };
    },
    watch: {},
    created() {
      this.getData();

    },
    components: { ETable, EDialog, EButton, EForm },
    computed:{
      ...mapGetters(['buttonList']),
    },
    beforeMount() {},
    methods: {
      onSearch() {
        this.searchForm.current = 1;
        this.getData();
      },
      changePage(current) {
        this.searchForm.current = current;
        this.getData();
      },
      changeSize(size) {
        this.searchForm.size = size;
        this.getData();
      },

      async getData() {
        let res = await Http.esignFlowList(this.searchForm);
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.count = res.data.total;
        }
      },
      async download(signFlowId) {
        let that = this
        that.files = [{fileName:"　　　　　　　　　　"}]
        let res = await Http.fileDownloadUrl({signFlowId: signFlowId});
        if (res.code == 200) {
          that.files = res.data
          that.showfiles = true
        }
      },
      async urge(signFlowId){
        let that = this
        let res = await Http.draftUrge({signFlowId: signFlowId});
        if (res.code === '0') {
          that.$message.success("催办成功")
        }else{
          that.$message.error(res.message)
        }
      },
      async revoke(signFlowId){
        let that = this
        that.$messageBox.prompt('请输入撤回原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\S{0,50}$/,
          inputErrorMessage: '最多只能输入50个字'
        }).then(async ({ value }) => {
          if(value!=''){
            let res = await Http.revoke({signFlowId: signFlowId, revokeReason: value});
            if (res.code === '0') {
              that.$message.success("撤回成功")
              that.onSearch();
            }else{
              that.$message.error(res.message)
            }
          }else{
            that.$message.error("请输入撤回原因")
          }
          
        }).catch(() => {    
        });
        
      },
      handleCommand(url){
        window.open(url)
      }
    }
  };
</script>

<style lang="scss" scoped>
.ws {
  width: 100%;
}
</style>
